import { UserKnowledgeCheckResults } from 'features/knowledge-checks/knowledge-check'

/** `picked` when the check has no correct answers to judge a pick by. */
export type PickResult = 'correct' | 'incorrect' | 'picked'

export type AnsweredPick = { id: string; text: string; result: PickResult }

export type AnsweredQuestion = {
	id: string
	question: string
	picks: AnsweredPick[]
}

/**
 * The participant's picks per question. Options they did not pick are
 * dropped, so a missed correct answer is not revealed before the review.
 */
export const answeredQuestions = (
	results: UserKnowledgeCheckResults,
	useCorrectAnswers: boolean
): AnsweredQuestion[] =>
	results.questions.map(question => ({
		id: question.id,
		question: question.question,
		picks: question.options
			.filter(option => option.selected)
			.map(option => ({
				id: option.id,
				text: option.answer,
				result: !useCorrectAnswers
					? 'picked'
					: option.correct
					? 'correct'
					: 'incorrect',
			})),
	}))
